import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TaskBoardDropType, TaskBoardTaskType } from '../../taskBoard/taskBoardTypes';

export interface TaskBoardDraggableState {
    draggingTask: TaskBoardTaskType | null;
    drop: TaskBoardDropType | null;
}

const initialState: TaskBoardDraggableState = {
    draggingTask: null,
    drop: null,
};

export const taskBoardDraggableSlice = createSlice({
    name: 'taskBoardDraggable',
    initialState,
    reducers: {
        setterTaskBoardDraggable: (state, action: PayloadAction<Partial<TaskBoardDraggableState>>) => {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

export const { setterTaskBoardDraggable } = taskBoardDraggableSlice.actions;

export default taskBoardDraggableSlice.reducer;
